import React, { useEffect, useState } from "react";
import SingleUserTestimonial from "../components/SingleUserTestimonial";
import AdminPanelGeneralHeading from "../components/AdminPanelGeneralHeading";
import SuccessAlert from "../components/SuccessAlert";
import ErrorAlert from "../components/ErrorAlert";
import NothingToShow from "../../components/NothingToShow";

export default function UserQueries() {
  // State Handling
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [fetchedData, setFetchedData] = useState();
  const [loading, setLoading] = useState(false);

  // --------- Reading/Fetching Queries From Database ---------
  const readingData = async () => {
    setLoading(true);

    try{
      const response = await fetch("https://hotelbnb-backend.onrender.com/read-contacts");
    const result = await response.json();

    if (!response.ok) {
      setSuccess("");
      setError("Queries can't be fetched");
    } else if (response.ok) {
      setTimeout(() => {
        setError("");
      }, 10000);
      const filteringQueries = Array.from(
        new Set(
          result.filter((query) => {
            if(query.user_query_type == "Question"){
              return query;
            }
            if(query.user_query_type == "Booking Cancellation"){
              return query;
            }
          })
        )
      );
      setFetchedData(filteringQueries);
    }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    readingData();
  }, []);

  // --------- Deleting ---------
  const deleteHandler = async (contactId) => {
    const response = await fetch(
      `https://hotelbnb-backend.onrender.com/delete-contact/${contactId}`,
      {
        method: "DELETE",
      }
    );

    const result = await response.json();

    if (!response.ok) {
      setSuccess("");
      setError("Query can't be deleted");
    } else if (response.ok) {
      setError("");
      setSuccess("Query Deleted Successfully");

      setTimeout(() => {
        setSuccess("");
      }, 2000);
    }

    // Reading the queries again
    readingData();
  };

  if (loading)
    return (
      <div className="d-flex flex-column gap-2 justify-content-center align-items-center loading-state">
        <div className="spinner-grow" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Fetching...</p>
      </div>
    );

  if (!loading)
  return (
    <>
      {/* Showing Alert based on http request response Start */}
      {success && <SuccessAlert successMsg={success} />}
      {error && <ErrorAlert errorMsg={error} />}
      {/* Showing Alert based on http request response End */}

      {/* All Queries Heading Start */}
      <AdminPanelGeneralHeading text="All Queries" />
      {/* All Queries Heading End */}

      {/* All Queries Cards Start*/}
      <div className="all-users-cards col-12 d-flex gap-4 flex-wrap justify-content-start align-items-stretch">
        {!fetchedData?.length ? <NothingToShow /> : ""}

        {fetchedData?.map((singleQuery) => {
          return (
            <SingleUserTestimonial
              key={singleQuery._id}
              userImg={singleQuery.user_img}
              userName={singleQuery.user_name}
              userEmail={singleQuery.user_email}
              userQueryType={singleQuery.user_query_type}
              testimonialText={singleQuery.user_message}
              bookingId={singleQuery.user_booking_id}
              contactId={singleQuery._id}
              deleteHandler={deleteHandler}
            />
          );
        })}
      </div>
      {/* All Queries Cards End */}
    </>
  );
}
